module.exports = __webpack_public_path__ + "img/as.b678034a.svg";